import { Component } from 'react'
import { Autocomplete, Box, Button, TextField, Typography } from '@mui/material'
import '../history.css';
import { Colors } from '../../../../Styles/Colors'
import { CommonPatientDetails, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../../Components/Loader';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { Medical_History_Problems, whenItAcuredList, durationsList, status_list } from '../../../../Utility/Constants';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { DataGrid } from '@mui/x-data-grid';
import { CheckAccessFunc, ContentInTooltip } from "../../../../Components/CommonFunctions/CommonFunctions";
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

const findValue = (list = [], value) => {
  return list?.find(item => item.value ? item.value === value : value) || null;
}
export default class DocMedicalHistory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      medicalHistoryData: [],
      selectedProblem: "",
      comments: '',
      patientDetails: {},
      clinicId: '',
      appointmentId: '',
      patientId: '',
      bloodGroup: '',
      selectedID: null,
      isEdit: false,
      deletePop: false,
      // for fo 
      withOutAppointment: {},
      doctor_id: "",
      // doctor problem list
      doctorPrblmList: [],
      selectedAccured: "",
      duration: "",
      duration_mode: "days",
      status: "true",
    }
  }

  componentDidMount() {
    let clinicId = getCachevalue('SelectedDoctorClinic')
    let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
    let ipPatientData = JSON.parse(getCachevalue("IppatientData"));
    let appointmentDetail = JSON.parse(getCachevalue("withoutAppointment"));
    const newState = {
      clinicId: clinicId,
      appointmentId: appointmentId?.appointment_id,
      patientId: appointmentId?.patient_id || ipPatientData?.patient_id,
      doctor_id: ipPatientData?.doctor_id,
      patientDetails: ipPatientData || appointmentId,
    };
    if (appointmentDetail?.patient_id === ipPatientData?.patient_id) {
      newState.withOutAppointment = appointmentDetail;
    }
    this.setState({
      ...newState
    }, () => {
      if (!this.props.is_From_Fo) {
        this.getPatientDetailData()
      }
      this.getDoctorMedicialHistory()
      if (this.props.fromDocOP || this.props.is_From_Ip_AdmissionDetails) {
        this.getSelectPrblmList();
      }
    })
  }

  getPatientDetailData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              patientDetails: { ...this.state.patientDetails, ...response?.data?.data }
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getSelectPrblmList = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_MEDICAL_PROBLEM_GET)
        .then(response => {
          if (response.data.status === 'success') {
            this.setState({
              doctorPrblmList: response.data.data || []
            })
          }
        }).catch(error => {
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  getDoctorMedicialHistory = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_MEDICAL_HISTORY + '?patient_id=' + this.state.patientId)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              medicalHistoryData: response?.data?.data?.patient_medical_history,
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  postDoctorMedicalHistoryData = () => {
    try {
      const data = {
        patient_id: this.state.patientId,
        appointment_id: this.state.appointmentId,
        disease_names: this.state.selectedProblem,
        occurred: this.state.selectedAccured || "",
        duration: +this.state.duration,
        duration_mode: this.state.duration_mode || "days",
        is_active: JSON.parse(this.state.status) || false,
      }
      if (this.state.selectedID) {
        data['id'] = this.state.selectedID
      }
      if (this.props.is_From_Fo) {
        data['doctor_id'] = this.state.doctor_id
      }
      this.LoaderFunction(true)
      RestAPIService.create(data, Serviceurls.DOC_MEDICAL_HISTORY)
        .then((response) => {
          if (response.data.status === 'success') {
            this.LoaderFunction(false)
            this.successMessage(response.data.message)
            this.clearMedicalHistory()
            this.getDoctorMedicialHistory()
          }
        }).catch((error) => {
          this.LoaderFunction(false)
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMessage(error.message)
    }
  }

  deleteMedicalHis = () => {
    try {
      let data = {
        id: this.state.selectedID,
        patient_id: this.state.patientId
      }
      this.setState({ removeData: true })
      this.LoaderFunction(true)
      RestAPIService.delete(Serviceurls.DOC_MEDICAL_HISTORY, data)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({ removeData: false })
            this.LoaderFunction(false)
            this.successMessage(response.data.message)
            this.clearMedicalHistory()
            this.getDoctorMedicialHistory()
          }
        }).catch((error) => {
          this.setState({ removeData: false })
          this.LoaderFunction(false)
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.setState({ removeData: false })
      this.LoaderFunction(false)
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  clearMedicalHistory = () => {
    try {
      this.setState({
        selectedProblem: "",
        selectedID: null,
        isEdit: false,
        deletePop: false,
        selectedAccured: "",
        duration: "",
        duration_mode: "days",
        status: "true",
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderAutoComplete = (label, stateKey, list, showKey = "label", valueKey = "value", width = "12vw") => {
    return (
      <Autocomplete
        clearIcon
        size='small'
        sx={{ width: width }}
        options={list || []}
        getOptionLabel={(option) => (typeof option === "string" ? option : option[showKey] || "")}
        value={findValue(list, this.state[stateKey]) || null}
        autoComplete='off'
        onChange={(event, newValue) => {
          const value = newValue[valueKey] ?? newValue;
          this.setState({
            [stateKey]: value,
            ...(stateKey === "duration_mode" && { duration: "" }),
          });
        }}
        renderInput={(params) => <TextField {...params} label={label} />}
      />)
  }

  restrictDuration = (durationMode, value) => {
    let restrictedValue = value;

    // Apply restriction only if the key is 'duration'
    const numValue = CommonValidation.numberOnly(value) ? Number(value) : 0;

    switch (durationMode) {
      case 'days': // Days
        restrictedValue = Math.max(1, Math.min(numValue, 31));
        break;
      case 'week': // Weeks
      case 'year': // Years
        restrictedValue = Math.max(1, Math.min(numValue, 15));
        break;
      case 'month': // Months
        restrictedValue = Math.max(1, Math.min(numValue, 12));
        break;
      default:
        restrictedValue = numValue;
        break;
    }
    return restrictedValue;
  }

  renderTextField = (label, stateKey, width = "16vw", maxLength = null) => {
    const handleChange = (e) => {
      const { value } = e.target;
      if (stateKey === "duration") {
        const newValue = this.restrictDuration(this.state.duration_mode, value) || "";
        this.setState({ [stateKey]: newValue })
      } else {
        this.setState({ [stateKey]: value })
      }
    };
    return (
      <TextField
        size='small'
        label={label}
        inputProps={maxLength ? { maxLength: maxLength } : {}}
        sx={{ width: width }}
        value={this.state[stateKey]}
        onChange={handleChange}
      />
    )
  }

  onClearClick = () => {
    this.clearMedicalHistory()
  }

  onAddClick = () => {
    this.postDoctorMedicalHistoryData()
  }

  renderRightSide = () => {
    const enableAdd = this.state.selectedProblem?.length > 0
    const checkuserAccess = (CheckAccessFunc("front_office", "In Patients", "History", "Medical History", "SubTab")?.editAccess ?
      (this.state.withOutAppointment?.is_ip || true) && enableAdd : enableAdd);
    try {
      return (
        <Box component={'div'} width={'92.5vw'}>
          <Box component={'div'} height={'2vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'}>
            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Medical History</Typography>
          </Box>
          <Box component={'div'} height={'12vh'} sx={{ backgroundColor: Colors.white }} overflow={'scroll'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Box paddingLeft="0.625vw" display={'flex'} alignItems={"center"} width={'80%'} columnGap={"0.5vw"}>
              {this.renderAutoComplete("Disease", "selectedProblem",
                (this.props.fromDocOP || this.props.is_From_Ip_AdmissionDetails) ? this.state.doctorPrblmList : Medical_History_Problems,
                "label", "value", "18vw"
              )}
              {this.renderAutoComplete('When it accured', "selectedAccured", whenItAcuredList, "label", "value", "18vw")}
              {this.renderTextField("Duration", "duration", "8vw")}
              {this.renderAutoComplete('Duration Mode', "duration_mode", durationsList, "label", "value", "10vw")}
              {this.renderAutoComplete('Status', "status", status_list, "label", "value")}
            </Box>
            <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'20%'}>
              <Button
                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                variant='outlined'
                onClick={this.onClearClick}
              >Clear</Button>
              <Button
                disabled={this.props.is_From_Fo ? !checkuserAccess : !enableAdd}
                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                variant='contained'
                onClick={this.onAddClick}
              >Add</Button>
            </Box>
          </Box>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  onEditHandler = (item) => {
    this.setState({
      selectedID: item.id,
      selectedProblem: item.disease_name,
      selectedAccured: item.occurred,
      duration: item.duration,
      duration_mode: item.duration_mode || "days",
      status: String(item.is_active),
      isEdit: true,
    })
  }

  onDeleteHandler = (item) => {
    try {
      if (!this.state.isEdit) {
        this.setState({
          deletePop: true,
          selectedID: item?.id
        })
      } else {
        this.errorMessage("You have clicked edit Button.So,You cannot able to delete")
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderTbl = () => {
    try {
      const columns = [
        {
          field: 'created_date', headerName: 'Date', flex: 0.16,
          renderCell: ({ row }) => (<Box>{row?.created_date || '-'}</Box>)
        },
        {
          field: 'disease_name', headerName: 'Disease', flex: 0.17,
          renderCell: ({ row }) => (ContentInTooltip(row?.disease_name, 20))
        },
        {
          field: 'occurred', headerName: 'When it accured', flex: 0.17,
          renderCell: ({ row }) => (ContentInTooltip(row?.occurred, 25))
        },
        {
          field: 'duration', headerName: 'Duration', flex: 0.17,
          renderCell: ({ row }) => (ContentInTooltip(`${row?.duration} ${row?.duration_mode}`, 20))
        },
        {
          field: 'is_active', headerName: 'Status', flex: 0.17,
          renderCell: ({ row }) => (<Typography >{row?.is_active ? "Active" : "Inactive"}</Typography>)
        },
        {
          field: 'action', headerName: 'Action', flex: 0.16, headerAlign: 'center', align: 'center',
          renderCell: ({ row }) => (<Box>
            <Button className='Common_Btn_Min_Width'
              onClick={() => this.onEditHandler(row)}
            >
              <Box height={'1.5vw'} width={'1.5vw'} component={'img'} src={ImagePaths.Edit.default} />
            </Button>
            <Button className='Common_Btn_Min_Width'
              onClick={() => this.onDeleteHandler(row)}
            >
              <Box height={'1.5vw'} width={'1.5vw'} component={'img'} src={ImagePaths.Delete.default} />
            </Button>
          </Box>)
        }
      ]

      return (
        <DataGrid
          rows={this.state.medicalHistoryData}
          sx={{ backgroundColor: Colors.white }}
          columns={columns}
          getRowId={(row) => row?.id}
          components={{
            NoRowsOverlay: () => (
              <Box className='eMed_conf_nodata' height={'40vh'}>
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          hideFooter
          headerHeight={40}
          disableRowSelectionOnClick
          loading={this.state.loading}
        />
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  popupClose = () => {
    try {
      this.setState({
        deletePop: false
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  render() {
    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
        <Box component={'div'} display={'flex'}>
          <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
            <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={(this.props.is_From_Ip_AdmissionDetails || this.props.is_From_Fo) ? false : true} />
          </Box>
        </Box>
        <Box component={'div'} mt={'0.5vw'}>
          <Box component={'div'} flex={0.35} border={'1px solid lightgray'}>
            {this.renderRightSide()}
          </Box>
          <Box component={'div'} mt={'.5vw'} height={'44vh'}>
            {this.renderTbl()}
          </Box>
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.deletePop ? <DeletePopup
          DeletTitle={`Are you sure you want to delete ?`}
          deleteAlertPopupClose={this.popupClose.bind(this)}
          removeData={this.deleteMedicalHis.bind(this)}
          disable={this.state.removeData}
        /> : null}
        <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}